import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import * as Styled from './OperatorsBreadCrumbs.style';
import arrowIcon from '../../../../global/media/arrow-breadCrumbs.svg';

const OperatorsBreadCrumbs = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = (push: string) => {
    history.push(push);
  };

  return (
    <Styled.ProductsBreadCrumbsContainer>
      <div className="breadCrumb" onClick={() => handleClick('/sources')}>
        {t('NetworkPage.BREADCRUMBS.PHARMACY_PAGE')}
      </div>
      <Styled.ProductsBreadCrumbIcon>
        <img src={arrowIcon} alt="arrow icon" />
      </Styled.ProductsBreadCrumbIcon>
      <div className="breadCrumb active">Операторы</div>
    </Styled.ProductsBreadCrumbsContainer>
  );
};

export default OperatorsBreadCrumbs;
